export default __webpack_public_path__ + "img/xmcwRxBO.82862d96.svg";